import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';

let initialized = false;
const APNS_TOKEN_KEY = 'apnsToken';
let registering = false; // prevent concurrent register calls
let requestedThisSession = false; // ask for permission only once per app session

export function initPush(store) {
  if (initialized) return;
  initialized = true;

  if (Capacitor.getPlatform() !== 'ios') return;

  // Listen for token registration
  PushNotifications.addListener('registration', (token) => {
    try {
      if (token && token.value) {
        const masked = (typeof token.value === 'string' && token.value.length > 12) ? `${token.value.slice(0,6)}…${token.value.slice(-6)}` : String(token.value);
        console.log('[PUSH][client] APNs registration event', { token: masked });
        store.dispatch('registerPushToken', token.value);
        try { localStorage.setItem(APNS_TOKEN_KEY, token.value); } catch (_) {}
      }
    } catch (e) {
      console.error('registerPushToken dispatch failed', e);
    }
  });

  PushNotifications.addListener('registrationError', (error) => {
    console.error('[PUSH][client] Push registration error:', error);
  });

  // Foreground notification handler (optional)
  PushNotifications.addListener('pushNotificationReceived', (notification) => {
    // You can show an in-app banner/toast here if needed
    // console.log('Push received', notification);
  });

  // Tap on notification
  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    try {
      const data = (action && action.notification && action.notification.data)
        ? action.notification.data
        : {};
      // If payload contains chatId, you can route the user there.
      // This requires access to router; consider emitting an app-level event.
      if (data.chatId) {
        window.dispatchEvent(new CustomEvent('openChatFromPush', { detail: { chatId: data.chatId } }));
      }
    } catch (e) {
      console.error('pushNotificationActionPerformed error', e);
    }
  });

  // If already logged in, try to register immediately
  if (store.state.token) {
    registerForPush(store);
  }
}

export async function registerForPush(store) {
  if (Capacitor.getPlatform() !== 'ios') return;
  if (registering) {
    console.log('[PUSH][client] registerForPush: already in-flight, skipping');
    return;
  }

  registering = true;
  try {
    const permStatus = await PushNotifications.checkPermissions();
    console.log('[PUSH][client] checkPermissions:', permStatus);
    let receive = permStatus && permStatus.receive;

    if (receive === 'prompt' && !requestedThisSession) {
      console.log('[PUSH][client] requesting permissions…');
      requestedThisSession = true;
      const req = await PushNotifications.requestPermissions();
      console.log('[PUSH][client] requestPermissions result:', req);
      receive = req && req.receive;
    }

    if (receive !== 'granted') {
      console.warn('[PUSH][client] notifications not granted; skipping register', { receive });
      return;
    }

    // Register with APNs
    console.log('[PUSH][client] calling PushNotifications.register');
    await PushNotifications.register();
    console.log('[PUSH][client] register() invoked');
  } catch (e) {
    console.error('[PUSH][client] registerForPush error:', e);
  } finally {
    registering = false;
  }
}

export function getStoredApnsToken() {
  try {
    return localStorage.getItem(APNS_TOKEN_KEY) || null;
  } catch (_) {
    return null;
  }
}

export async function unregisterFromPush(store) {
  const token = getStoredApnsToken();
  if (!token) return;
  try {
    await store.dispatch('unregisterPushToken', token);
  } catch (e) {
    console.error('unregisterPushToken dispatch failed', e);
  } finally {
    try { localStorage.removeItem(APNS_TOKEN_KEY); } catch (_) {}
  }
}
